import { APP_INITIALIZER, Provider } from '@angular/core';
import { NavigationError, Router } from '@angular/router';

function initResolverErrorLogging(router: Router): () => void {
  return () => {
    router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        console.error('Resolver error during navigation:', event.error);
      }
    });
  };
}

export const ResolverErrorLoggerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: initResolverErrorLogging,
  deps: [Router],
  multi: true,
};
